<template>
  <div id="Experience">
    <bg-video ref="bv" :filename="filename" :class="{ blur }" autoplay @ended="videoEnded"/>
    <div v-show="btnGroupVisiable" class="btn-wrap">
      <a class="btn" title="实景" @click="playVideo('LA/Experience')"/>
      <a class="btn" title="虚拟" @click="playVideo('VR/Experience')"/>
    </div>
    <guide-button class="btn-lt" @click.native="$router.push('/Start')">返回</guide-button>
    <guide-button v-show="!btnVisiable" class="btn-rt" @click.native="handleEnded">继续</guide-button>
    <guide-button v-show="btnVisiable" class="btn-rt" @click="$router.push('/TitlePage/01')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'Experience',
  data () {
    return {
      btnGroupVisiable: false,
      btnVisiable: false,
      blur: false,
      filename: 'Experience-2',
      narratePlayed: false,
    }
  },
  mounted () {

  },
  beforeDestroy () {
    this.$narrate.clear()
  },
  methods: {
    videoEnded () {
      this.filename = 'Experience'
      if (!this.narratePlayed) {
        this.$narrate.play('02', { auto: true, hideBtn: true }).then(_ => {
          this.handleEnded()
        })
      }
      this.narratePlayed = true
    },
    playVideo (filename) {
      this.blur = true
      this.$refs.bv.pause()
      this.$vplayer.play({ url: filename }).then(_ => {
        this.blur = false
      })
    },
    handleEnded () {
      this.$narrate.skip()
      this.$refs.bv.pause()
      this.btnGroupVisiable = true
      this.btnVisiable = true
    },
  },
}
</script>

<style lang="scss" scoped>
#Experience {
  position: relative;
  width: 19.2rem;
  height: 10.8rem;
  .btn-wrap {
    position: absolute;
    top: 2.2rem;
    width: 100%;
    height: 5.75rem;
    text-align: center;
    .btn {
      display: inline-block;
      width: 6.5rem;
      height: 5.75rem;
      margin: 0 0.2rem;
      cursor: pointer;
      &:first-child {
        background-image: url(./img/btn1.png);
        background-size: cover;
      }
      &:last-child {
        background-image: url(./img/btn2.png);
        background-size: cover;
      }
    }
  }
}
</style>
